<template>
  <div class="box-delivery-info">
    <a v-if="delivery.shippingInfo" href="javascript:void(0)" class="text--underline shipping-info" @click.prevent="showFormRegister()">{{ delivery.shippingInfoSlice }}</a>
    <button v-else-if="delivery.isCompleteRegisterEnable" type="button" class="btn btn-primary btn-shipping-complete-register shipping-info" @click.prevent="showFormRegister()">発送完了登録</button>
    <button v-else type="button" class="btn btn-basic btn-shipping-complete-register shipping-info" disabled="true">発送完了登録</button>

    <div v-if="showForm" :class="`box-form-delivery-info delivery-info-${delivery.deliveryNo}`" @click.stop>
      <strong>「追跡番号が記載されたURL」もしくは「配送事業者名と追跡番号」を入力してください。</strong>
      <div class="box-info-input">
        <div>{{ exampleRegisterText }}</div>
        <textarea v-model.trim="shippingInfoInput" class="form-control delivery-info" name="delivery-info" rows="3"></textarea>
        <button type="button" class="btn btn-primary m-t-sm" :disabled="!shippingInfoInput" @click="deliveryInfoRegister()">登録する</button>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryService from '@/services/deliveryservice'
import LoadingBlock from '@/components/LoadingBlock'

export default {
  props: {
    delivery: {
      type: Object,
      default () {
        return {}
      }
    },
    isFirstInfo: {
      type: Boolean,
      default: false
    },
    isLastInfo: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LoadingBlock
  },
  data () {
    return {
      showForm: false,
      shippingInfoInput: null,
      loader: null
    }
  },
  computed: {
    exampleRegisterText () {
      return '(例) ヤマト運輸：123412341234、日本郵便：123412341234'
    }
  },
  methods: {
    showFormRegister () {
      this.showForm = !this.showForm
    },
    deliveryInfoRegister () {
      if (!this.shippingInfoInput) {
        return
      }
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: this.delivery.deliveryNo,
        shippingInfo: this.shippingInfoInput
      }
      DeliveryService.updateShippingInfoRequest(params)
        .then((response) => {
          this.delivery.shippingInfo = this.shippingInfoInput
          this.$emit('registerSuccess', this.delivery)
          this.loader && this.loader.hide()
          this.showForm = false
        })
        .catch((error) => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    }
  },

  watch: {
    showForm (value) {
      let screenWidth = window.innerWidth
      let deliveryTableWrapperSelector = $('.table-wrapper')
      if (screenWidth < 1400 && value) {
        if (this.isFirstInfo) {
          deliveryTableWrapperSelector.css('padding-top', '50px')
        }
        if (this.isLastInfo) {
          deliveryTableWrapperSelector.css('padding-bottom', '50px')
        }
      } else {
        deliveryTableWrapperSelector.css({
          'padding-top': 'unset',
          'padding-bottom': 'unset'
        })
      }
    }
  },
  mounted () {
    this.shippingInfoInput = this.delivery.shippingInfo
    let deliveryInfoClass = `.delivery-info-${this.delivery.deliveryNo}`
    window.addEventListener('click', (e) => {
      if (document.querySelector(deliveryInfoClass) !== null && !document.querySelector(deliveryInfoClass).contains(e.target)) {
        if (this.showForm) {
          this.showForm = false
        }
      }
    })
  },

  beforeDestroy () {
    this.showForm = false
    this.shippingInfoInput = null
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/DeliveryRegisterInfoBubble.vue